<script>
  export let selected, groups, onChange;
  import { External, M } from '../../external';
</script>
<div class="popup-widget-wrapper">
  <div class="popup-input-wrapper">
    <h5 class="f-15">{M.GROUP}</h5>
    <span class="light-gray-text">{M.MOVE_PAGE_TO_GROUP}</span>
    <select bind:value={selected} on:change={() => onChange(selected)}>
      <option value="">{M.ROOT_MENU}</option>
      {#each groups as group}
        <option value={group.pageGroup.id}>{group.pageGroup.name}</option>
      {/each}
    </select>
  </div>
</div>
